import { defineElement, BaseElement } from '@webtides/element-js';

//dependencies
import '../../../legacy-library/webcomponents/svg-icon/svg-icon';
import FrameSelectorEvent from '../../structures/frame-selector/FrameSelectorEvent';

import Shuffle from 'shufflejs';
class SeriesPage extends BaseElement {
    connected() {
        this._cards = this.querySelectorAll('series-card');
        this.initShuffle();

        if (window.location.hash.includes(this.categoryLabel)) {
            this.toggleContent(true);
        }

        //requesUpdate to wait for prod-images to be rendered
        this.requestUpdate();
    }

    initShuffle() {
        // Make sure the underlying elements have rendered correctly.
        requestAnimationFrame(() => {
            //call shuffle when images are loaded
            this._shuffle = new Shuffle(this.$refs.shuffleArea, {
                itemSelector: '.series-card-component',
            });
        });
    }

    events() {
        return {
            '[ref=frameSelector]': {
                [FrameSelectorEvent.FRAME_CLICK]: e => {
                    const activeFrame = e.detail === 'ALL' ? Shuffle.ALL_ITEMS : e.detail;
                    this.updateFrameImages();
                    this._shuffle.filter(activeFrame);
                },
            },
            '[ref=seriesBtn]': {
                click: () => this.toggleContent(),
            },
            '[ref=categoryBtn]': {
                click: () => this.toggleContent(true),
            },
        };
    }

    get categoryLabel() {
        return this.$refs.categoryBtn.dataset.label;
    }
    get seriesLabel() {
        return this.$refs.seriesBtn.dataset.label;
    }

    updateFrameImages() {
        const activeFrame = this.$refs.frameSelector.activeFrame;
        this._cards.forEach(card => {
            card.currentFrameId = activeFrame;
        });
    }

    toggleContent(showCategory = false) {
        if (showCategory) {
            this.$refs.seriesContent.classList.add('hidden');
            this.$refs.categoryContent.classList.remove('hidden');
            this.$refs.contentIndicator.active = 1;

            window.location.hash = this.categoryLabel;
        } else {
            this.$refs.seriesContent.classList.remove('hidden');
            this.$refs.categoryContent.classList.add('hidden');
            this.$refs.contentIndicator.active = 0;

            this._shuffle?.update();

            window.location.hash = this.seriesLabel;
        }
    }
}

defineElement('series-page', SeriesPage);
